import React from 'react';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from 'src/common/emerald-modal-manager/emerald-modal-manager';
import XLRLogger from 'src/common/helpers/logger';
import { IReceipt } from 'src/common/interfaces/dtos/IReceipt';
import { printReceipts } from 'src/devices/printer-operations';
import { printBarcode } from './business-logic/service/print-barcode.service';
import AuthenticationModal, {
  IAuthenticationModalProps,
} from 'src/common/components/authentication-modal/authentication-modal';
import { popupMessage } from 'src/messages/business-logic/popup-message';

export const showPrintBarcodeDialog = (): void => {
  pushEmeraldModal(<PrintBarcodeModal />);
};

const PrintBarcodeModal = (): JSX.Element => {
  const onCancel = (): void => {
    popEmeraldModal();
  };

  const onSubmit = async (
    userName: string,
    password: string,
    setError: React.Dispatch<React.SetStateAction<string | undefined>>,
  ): Promise<void> => {
    await printBarcode(userName, password)
      .then(
        async (receipts: IReceipt[]): Promise<void> => {
          await printReceipts(receipts).catch(popupMessage);
          popEmeraldModal();
        },
      )
      .catch((err): void => {
        XLRLogger.error({
          message: err,
          source: 'barcode/print-barcode.tsx',
        });
        setError('Invalid Username or Password');
      });
  };

  const modalProps: IAuthenticationModalProps = {
    onSubmit: onSubmit,
    onCancel: onCancel,
    title: 'POSStaffBarcodeDetailsViewLogin_Enterlogin',
    dataTestId: 'print-barcode',
    usernameLabel: 'UserIdLabel',
    passwordLabel: 'UserPassword',
    submitLabel: 'SignInView_Print',
    cancelLabel: 'Cancel',
  };

  return <AuthenticationModal {...modalProps} />;
};

export default PrintBarcodeModal;
